<template>
    <div>
        <div class="modal-body">
            <el-button @click="handleCreateTeacher()">添加老师</el-button>

            <el-button @click="handleDeleteTeacher()">删除老师</el-button>

            <el-button @click="handleHideTeacher()">隐藏老师</el-button>

            <el-button @click="handleActiveTeacher()">显示隐藏老师</el-button>
        </div>
    </div>


</template>

<script>
    export default {
        name: "Dialog_TableSiteModal",
        data() {
            return {
                button_loading: false,
                title: '设置',
                loading: true,
                classForm: {},
                classx: '',
                course: {},
                classrooms: '',
                data2: {},
                modal: ''
            }
        },
        created() {
            this.$parentInfo = this.$root.$children[0].$refs['dashboard'].$refs[this.$route.path];
            this.loading = false;
        },
        methods: {
            handleCreateTeacher() {
                this.$Win.openModal('Dialog_GiveTeacherToSemester', 350, 400, '新增教师');
            },
            handleDeleteTeacher() {
                this.$Win.openModal('Dialog_DeleteTeacher', 440, 430, '删除老师');
            },
            handleHideTeacher() {
                this.$Win.openModal('Dialog_HideTeacher', 440, 430, '隐藏老师');
            },
            handleActiveTeacher() {
                this.$Win.openModal('Dialog_ActiveTeacher', 440, 430, '显示老师');
            },

        }
    }
</script>

<style>
    .modal {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        z-index: 3000;
    }

    .modal-dialog {
        max-width: 500px;
        margin: 30px auto;
    }

    .modal-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 10px 15px;
        border-bottom: 1px solid #e9ecef;
    }

    .modal-header {
        font-size: 12px;
    }

    .modal-title {
        margin: 0;
        line-height: 1.5;
    }

    .modal-body {
        position: relative;
        flex: 1 1 auto;
        padding: 15px;
    }

    .modal-content {
        position: relative;
        display: flex;
        flex-direction: column;
        background-color: #fff;
        background-clip: padding-box;
        border: 1px solid rgba(0, 0, 0, .18);
        border-radius: .3rem;
        outline: 0;
        min-height: 300px;
        box-shadow: 0px 0px 20px 2px rgba(0, 0, 0, 0.12);
    }

    .modal .close {
        font-size: 20px;
        text-shadow: 0 1px 0 #fff;
    }

    .modal .close:hover {
        opacity: .5;
    }
</style>
